import React, { useState } from "react";
import { terminalAPI } from "../../services/api";
import "./POSProductSync.css";

const POSProductSync = ({ id, onSyncComplete }) => {
  const [syncing, setSyncing] = useState(false);
  const [syncResult, setSyncResult] = useState(null);
  const [error, setError] = useState(null);
  const [showDetails, setShowDetails] = useState(false);

  const handleSync = async () => {
    try {
      setSyncing(true);
      setError(null);
      setSyncResult(null);

      const response = await terminalAPI.syncProductsFromStripe();
      setSyncResult(response.data);

      // Call the onSyncComplete callback if provided
      if (onSyncComplete) {
        onSyncComplete(response.data);
      }
    } catch (error) {
      setError(
        error.userMessage || "Failed to sync products. Please try again."
      );
    } finally {
      setSyncing(false);
    }
  };

  const formatTimestamp = (timestamp) => {
    if (!timestamp) return "";
    const date = new Date(timestamp);
    return date.toLocaleString();
  };

  return (
    <div className="pos-product-sync" id={id}>
      <div className="pos-product-sync-header">
        <h3>Product Sync</h3>
        <button
          className="pos-sync-button"
          onClick={handleSync}
          disabled={syncing}
        >
          {syncing ? (
            <>
              <span className="pos-sync-spinner"></span>
              Syncing...
            </>
          ) : (
            <>
              <i className="fas fa-sync-alt"></i>
              Sync Products from Stripe
            </>
          )}
        </button>
      </div>

      {error && <div className="pos-sync-error">{error}</div>}

      {syncResult && (
        <div className="pos-sync-result">
          <div className="pos-sync-result-header">
            <div className="pos-sync-result-info">
              <span className="pos-sync-success-icon">
                <i className="fas fa-check-circle"></i>
              </span>
              <div className="pos-sync-result-text">
                <p className="pos-sync-result-message">{syncResult.message}</p>
                <p className="pos-sync-result-timestamp">
                  Synced at: {formatTimestamp(syncResult.syncedAt)}
                </p>
              </div>
            </div>
            <button
              className="pos-sync-details-toggle"
              onClick={() => setShowDetails(!showDetails)}
            >
              {showDetails ? "Hide Details" : "Show Details"}
            </button>
          </div>

          {showDetails && (
            <div className="pos-sync-details">
              <h4>Synced Products ({syncResult.productCount})</h4>
              <div className="pos-sync-products-list">
                {syncResult.products.map((product) => (
                  <div key={product.id} className="pos-sync-product-item">
                    <div className="pos-sync-product-image">
                      {product.image ? (
                        <img src={product.image} alt={product.name} />
                      ) : (
                        <div className="pos-sync-product-no-image">
                          <i className="fas fa-image"></i>
                        </div>
                      )}
                    </div>
                    <div className="pos-sync-product-info">
                      <h5>{product.name}</h5>
                      <p className="pos-sync-product-price">
                        ${(product.price / 100).toFixed(2)}
                      </p>
                      <p className="pos-sync-product-category">
                        {product.category}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default POSProductSync;
